import type { Collector } from "./types";
import { isBrowser } from "./types";

export const fontsCollector: Collector<string[]> = {
  name: "fonts",
  version: 1,
  timeoutMs: 1000,
  collect() {
    return detectFonts();
  },
};

function detectFonts(): string[] {
  if (!isBrowser) return [];
  const candidates = [
    "Arial",
    "Helvetica",
    "Times New Roman",
    "Courier New",
    "Georgia",
    "Verdana",
    "Trebuchet MS",
    "Comic Sans MS",
  ];
  const baseFonts = ["monospace", "sans-serif", "serif"];
  const testStr = "mmmmmmmmmmlli";
  const testSize = "72px";
  const body = document.body || document.documentElement;

  const span = document.createElement("span");
  span.style.fontSize = testSize;
  span.innerHTML = testStr;
  const defaultW: Record<string, number> = {},
    defaultH: Record<string, number> = {};
  for (const bf of baseFonts) {
    span.style.fontFamily = bf;
    body.appendChild(span);
    defaultW[bf] = span.offsetWidth;
    defaultH[bf] = span.offsetHeight;
    body.removeChild(span);
  }

  const present: string[] = [];
  for (const font of candidates) {
    let detected = false;
    for (const bf of baseFonts) {
      span.style.fontFamily = `'${font}',${bf}`;
      body.appendChild(span);
      const w = span.offsetWidth,
        h = span.offsetHeight;
      body.removeChild(span);
      if (w !== defaultW[bf] || h !== defaultH[bf]) {
        detected = true;
        break;
      }
    }
    if (detected) present.push(font);
  }
  return present.sort();
}
